import { useContext } from "react";
import { Badge, Card, Flex, Loader, ScrollView } from "@aws-amplify/ui-react";
import CloseIcon from "@mui/icons-material/Close";

import { LayoutContext } from "layout/context/LayoutContext";

const StandardFilterCard = ({ title, loading, list, onRemove }) => {
  const { me } = useContext(LayoutContext);

  return (
    <Card borderRadius="medium" variation="outlined">
      <h5>{title}</h5>
      <ScrollView maxHeight="120px">
        <Flex wrap="wrap" rowGap="10px" columnGap="10px">
          {loading ? (
            <Loader />
          ) : (
            list?.map((item) => (
              <Badge key={item.id}>
                {item.name}
                &nbsp;
                {me.companyID !== item.id && (
                  <CloseIcon
                    style={{ cursor: "pointer" }}
                    fontSize="inherit"
                    onClick={() => onRemove(item.id)}
                  />
                )}
              </Badge>
            ))
          )}
        </Flex>
      </ScrollView>
    </Card>
  );
};

export default StandardFilterCard;
